import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import Tooltip from './Tooltip';
import SortToggle from './SortToggle';
import { ColumnHeader } from './Grid';
import ColumnDropdown from './ColumnDropdown';
import isSortableColumn from "../utils/isSortableColumn";
import getSortKeyFromColumn from "../utils/getSortKeyFromColumn";
import isExistingAdvancedSort from "../utils/isExistingAdvancedSort";
import get from 'lodash/get';

const ColumnHeaderInner = styled<any, any>('div')`
    ${propStyles};
`;

ColumnHeaderInner.defaultProps = {
    display: "flex",
    alignItems: "center",
    height: "1em"
};

const ColumnLabel = styled<any, any>('div')`
    ${propStyles};
`;

ColumnLabel.defaultProps = {
    flex: "1 1 auto",
    textAlign: "center"
};

export const Column: React.SFC<any> = ({ theme, dataStore, column, selectedGroupIndex, setSelectedGroup, children, ...props }) => {
    const key = getSortKeyFromColumn(column);
    const sortable = isSortableColumn(column);
    let direction = undefined;

    if (dataStore.advancedSort && isExistingAdvancedSort(column, dataStore.advancedSort)) {
        direction = get(dataStore, 'advancedSort.direction', '');
    } else {
        direction = get(dataStore.propertySort.find(c => c.key === key), 'direction', '');
    }

    return (
        <ColumnHeader
            {...theme.ColumnHeader}
            {...props}
            width={column.width}
            verticalAlign={column.verticalAlign}
            textAlign={column.textAlign || "center"}
        >
            <ColumnHeaderInner
                {...theme.ColumnHeaderInner}
            >
                {
                    column.type === 'dropdown'
                        ? (
                            <ColumnDropdown
                                column={column}
                                selectedGroupIndex={selectedGroupIndex}
                                setSelectedGroup={setSelectedGroup}
                            />
                        )
                        : (
                            <ColumnLabel
                                {...theme.ColumnLabel}
                                textAlign={column.textAlign || "center"}
                            >
                                <Translate>{column.label}</Translate>
                                <Tooltip
                                    content={column.disclaimers}
                                    verticalAlign="sub"
                                />
                            </ColumnLabel>
                        )
                }
                {
                    sortable && (
                        <SortToggle
                            direction={direction}
                            onClick={() => dataStore.toggleSort(column)}
                        />
                    )
                }
            </ColumnHeaderInner>
            {children}
        </ColumnHeader>
    );
};

export default inject('dataStore')(withTheme(observer(Column))) as any;


// WEBPACK FOOTER //
// ./src/Components/Column.tsx